<script>
import UpdatePassword from '../../components/UpdatePassword.vue'
import md5 from 'md5'
import { Encrypt } from '../../service/Encrypt'

export default {
  mixins: [UpdatePassword],
  data() {
    return {
      userAccountId: null,
    }
  },
  methods: {
    popup(userAccountId) {
      this.show = true
      this.userAccountId = userAccountId
    },
    turnBack() {
      this.show = false
      this.newPassword = null
      this.againPassword = null
    },
    update() {
      return this.$http
        .put(`/auth-service/auth/admin-update-password`, {
          userId: this.userAccountId,
          newPassword: Encrypt(this.newPassword),
        })
        .then((res) => {
          return this.$http
            .get('/employees/change-date?userAccountId=' + this.userAccountId, {
              headers: {
                jumpAuth: true,
              },
            })
            .then((r) => {
              if (res.data.success) {
                this.$message(
                  '',
                  'パスワードのリセットに成功しました',
                  'SUCCESS'
                )
                this.turnBack()
              } else {
                this.$showApiError(res)
                // this.$message('', 'パスワードのリセットに失敗しました', 'ERROR')
              }
            })
        })
        .catch(() => {
          this.$message('', 'パスワードのリセットに失敗しました', 'ERROR')
        })
    },
  },
}
</script>

<style></style>
